export const getAccessToken = state => state.user.authentication.accessToken || null;